import type {
  SeatSlice,
  Person,
  SeatSegment,
} from "@b2bportal/air-booking-api";
import type { TripSlice, Airport } from "@b2bportal/air-shopping-api";
import { AirlineIcon } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { removeTimezone } from "@hopper-b2b/utilities";
import { formatDateTime, DateTimeFormatStyle } from "@hopper-i18n/formatter";
import { SeatSelections } from "..";
import type { SelectedSeatSegment } from "../SelectedSeats";

import styles from "./styles.module.scss";

export const FlightSliceRow = ({
  slice,
  seatSlice,
  airports,
  selectedSeatSegments,
  passengers,
  onEdit,
}: {
  slice: TripSlice;
  seatSlice: SeatSlice;
  airports: { [key: string]: Airport };
  selectedSeatSegments: SelectedSeatSegment[];
  passengers: Person[];
  onEdit: (seatSegment: SeatSegment) => void;
}) => {
  const { t, locale } = useI18nContext();

  return (
    <div className={styles.FlightSliceRow}>
      {slice.segmentDetails.map((seg, i: number) => {
        const seatAvailable = seatSlice.segments[i].seatsAvailable;
        const handleEdit = () => {
          onEdit(seatSlice.segments[i]);
        };

        const departureDate = formatDateTime(
          new Date(removeTimezone(seg.departureTime)),
          locale,
          DateTimeFormatStyle.ShortMonthDayShortWeekday
        );

        const isSeatSelectedForSegment = selectedSeatSegments.find(
          (seatSegment) =>
            seatSegment.originCode === seg.originCode &&
            seatSegment.destinationCode === seg.destinationCode
        );

        return (
          <>
            <div className="segment-row">
              <div className="left">
                <AirlineIcon className="icon" airlineCode={seg.airlineCode} />
                <div className="content">
                  <p className="route">
                    {t("seats.cityToCity", {
                      originCity: airports[seg.originCode].cityName,
                      destinationCity: airports[seg.destinationCode].cityName,
                    })}
                  </p>
                  <p className="date">{departureDate}</p>
                  <p className="airline">{seg.airlineName}</p>
                </div>
              </div>
              {seatAvailable ? (
                <button onClick={handleEdit}>
                  {isSeatSelectedForSegment ? t("edit") : t("choose")}
                </button>
              ) : null}
            </div>
            {!seatAvailable ? (
              <p className="unavailable">{t("seats.unavailableWarning")}</p>
            ) : (
              <SeatSelections
                selectedSeatSegments={selectedSeatSegments}
                passengers={passengers}
                destinationCode={seg.destinationCode}
                originCode={seg.originCode}
              />
            )}
          </>
        );
      })}
    </div>
  );
};
